import classNames from "classnames";
import React, { UIEvent } from "react";

import { useCalendarContext } from "../../context/calendar_context";
import { CONTROLS_HEIGHT, FILTERS_ROW_HEIGHT, MIN_DAY_WIDTH } from "../calendar";
import calendarCss from "../calendar.module.scss";
import css from "./calendar_header.module.scss";
import { Days } from "./days";
import { Months } from "./months";
import { Weeks } from "./weeks";

type CalendarHeaderProps = {
  headerRef: React.MutableRefObject<HTMLDivElement>;
  onScroll: (e: UIEvent<HTMLDivElement>) => void;
};

export const CalendarHeader = ({ headerRef, onScroll }: CalendarHeaderProps): JSX.Element => {
  const { dayWidth, days, weeks, months, zoomMode } = useCalendarContext();
  const showDayHeaders = dayWidth >= MIN_DAY_WIDTH;

  return (
    // Header div and calendar view div are separated to make sticky header feature working.
    <div
      ref={headerRef}
      style={{ top: CONTROLS_HEIGHT + FILTERS_ROW_HEIGHT }}
      className={classNames(css.headerStickyContainer, calendarCss.hideScrollbar)}
      onScroll={onScroll}
    >
      <div
        style={{ width: days.length * dayWidth }}
        className={classNames(css.headerWrapper, calendarCss.hideScrollbar)}
      >
        <Months months={months} />
        <Weeks weeks={weeks} zoomMode={zoomMode} />
        {showDayHeaders && <Days days={days} />}
      </div>
    </div>
  );
};
